/** @format */

import React, { useState, useMemo } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import { safeLanguageUrlPrefix } from '@services/drupal-services';
import { startLazyLoad } from '@services/lazy-load';

type TimelineEventProps = {
  description: string;
  nid: string;
  node_alias: string;
  title: string;
  widen_image_alt_text: string;
  widen_image_id: string;
};

/**
 * Timeline Slider.
 */
const TimelineSlider = (): JSX.Element | null => {
  const [eventsData, setEventsData] = useState<TimelineEventProps[]>([]);

  /**
   * Slider settings.
   */
  const settings = {
    className: 'timeline-slider',
    dots: false,
    lazyLoad: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    beforeChange: () => {
      setTimeout(() => {
        startLazyLoad();
      }, 0);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  /**
   * Fetch data.
   */
  useMemo(() => {
    axios
      .get(
        `/${safeLanguageUrlPrefix()}rest-api/varian-timeline-data?_format=json`
      )
      .then((response) => {
        setEventsData(response?.data?.events);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  /**
   * Render.
   */
  if (eventsData.length > 0) {
    return (
      <Slider {...settings}>
        {eventsData &&
          eventsData.map((event) => {
            const {
              nid,
              description,
              widen_image_id: image,
              widen_image_alt_text: altText,
              title,
            } = event;
            return (
              <div key={nid} className="timeline-slide">
                <div>
                  <div>
                    {image && (
                      <img
                        data-src={`https://varian.widen.net/content/${image}/webp?w=196&h=196&crop=true&quality=40`}
                        alt={altText}
                        className="img-responsive lazy"
                      />
                    )}
                  </div>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{ __html: description }}></div>
                  <h3>{title}</h3>
                </div>
              </div>
            );
          })}
      </Slider>
    );
  }
  return null;
};

export default TimelineSlider;
